import moment from "moment";

// IBGE costuma publicar o índice IPCA do mês até por volta do dia 15;
// damos uma folga até o dia 20 antes de sinalizar que a sincronização automática pode estar falhando.
export const DIA_LIMITE_PUBLICACAO_IBGE = 20;

export const isSincronizacaoIndiceIPCAAtrasada = () => moment().date() > DIA_LIMITE_PUBLICACAO_IBGE;
